module.exports = __webpack_public_path__ + "img/7taskStatus.26cf6907.svg";